import { useApp } from '@/context/AppContext';

interface AppLogoProps {
  className?: string;
}

export function AppLogo({ className = 'h-6 w-6' }: AppLogoProps) {
  const { logoAriaLabel } = useApp();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56 56"
      className={className}
      aria-label={logoAriaLabel}
      role="img"
    >
      <g fill="currentColor" transform="translate(6.885, 4)">
        <path d="M14.5925,21.6153a7.0434,7.0434,0,0,1,7.0228-7.0228h0a7.0433,7.0433,0,0,1,7.0227,7.0228v9.628h4.5309v-9.628a11.5536,11.5536,0,1,0-23.1072,0v9.628h4.5308Z" />
        <path d="M14.5925,31.2433v9.628a7.0433,7.0433,0,0,0,7.0227,7.0227h0a7.0433,7.0433,0,0,0,7.0227-7.0227v-9.628Z" />
        <path d="M5.5308,21.6153a16.0845,16.0845,0,1,1,32.1689,0v9.628h4.5308v-9.628a20.6153,20.6153,0,1,0-41.23,0v9.628H5.5308Z" />
      </g>
    </svg>
  );
}
